import { config, getAllVariablesFlat } from '.';

export const QUERY_DOC_ID = '001';
export const INTERVIEW_DOC_ID = '002';
export const LEGAL_PROCESS_DOC_ID = '003';
export const LEGAL_PROCESS_ACTION_DOC_ID = '004';
export const CONCILIATION_REQUEST_DOC_ID = '005';
export const CITATION_DOC_ID = '006';
export const CONSTANCY_ASSISTANCE_DOC_ID = '007';
export const CONCILIATION_ACT_DOC_ID = '008';
export const CONSTANCY_IMPOSSIBILITY_DOC_ID = '009';
export const CITATION_COMPLIANCE_DOC_ID = '010';

export const ETHICAL_INBOX_DOC_ID = '100';

export const appConfig = {
  ui: {
    requestFormColumns: 4,
  },
  /**
   * API configs
   */
  api_routes: {
    prefix: process.env.REACT_APP_API_URI,
    modules: {
      documents: {
        prefix: '/documents',
        services: {
          home: '/',
          documentStore: '/documentStore',
          documentView: '/documentView',
          documentDelete: '/documentDelete',
          stageDocuments: '/stageDocuments',
          legalProcessActionDocuments: '/legalProcessActionDocuments',
          personDocuments: '/personDocuments',
          personInfo: '/personInfo',
          userSessionExtention: '/ux',
          getActionType: '/getActionType',
          getDocumentTypes: '/getDocumentTypes',
        },
      },
      conciliation: {
        prefix: '/conciliation',
        services: {
          home: '/',
          assessmentRequest: '/assessmentRequest',
          requestView: '/requestView',
          conciliationRequest: '/conciliationRequest',
        },
      },
      conciliationAdmin: {
        prefix: '/conciliation/admin',
        services: {
          home: '/requests',
          view: '/requests/view',
          update: '/requests/update',
          delete: '/requests/delete',
          paymentChecked: '/requests/paymentChecked',
          export: '/requests/export',
          assessment: '/assessment',
          postpone: '/postpone',
          approval: '/approval',
          publishResults: '/publishResults',
        },
      },
      ethicalInbox: {
        prefix: '/ethicalInbox',
        services: {
          report: '/report',
          view: '/view',
          response: '/response',
        },
      },
      ethicalInboxAdmin: {
        prefix: '/ethicalInbox/admin',
        services: {
          home: '/report',
          view: '/report/view',
          update: '/report/update',
          delete: '/report/delete',
          response: '/report/response',
          export: '/report/export',
        },
      },
    },
  },

  fsjpHomeUrl: process.env.REACT_APP_urlSIPO as string,
  SIPOUserHomeUrl: process.env.REACT_APP_SIPOUserHomeUrl as string,
  SIPOListadoActuacionesURL: process.env.REACT_APP_uriSIPOActuaciones as string,

  react_routes: {
    prefix: '',
    modules: {
      documents: {
        prefix: '/documents',
        services: {
          home: '/',
          newDocument: '/new',
          documentView: '/documentView',
          documentEdit: '/documentEdit',
          documentDelete: '/documentDelete',
          stageDocuments: '/stageDocuments',
          legalProcessActionDocuments: '/legalProcessActionDocuments',
          personDocuments: '/personDocuments',
          userSessionExtention: '/ux',
        },
      },
      conciliation: {
        prefix: '/conciliation/request',
        services: {
          home: '/',
          viabilityQuery: '/viabilityQuery',
          conciliationRequest: '/conciliationRequest',
          view: '/view',
          viewForConvened: '/viewForConvened',
        },
      },
      conciliationAdmin: {
        prefix: '/conciliation/request/admin',
        services: {
          home: '/',
          edit: '/edit',
          update: '/update',
          delete: '/delete',
          export: '/export',
          assessment: '/assessment',
          approval: '/approval',
          publishResults: '/publishResults',
        },
      },

      ethicalInbox: {
        prefix: '/ethicalInbox',
        services: {
          new: '/new',
          view: '/view',
          response: '/response',
        },
      },
      ethicalInboxAdmin: {
        prefix: '/ethicalInbox/request/admin',
        services: {
          home: '/',
          edit: '/edit',
          view: '/view',
          delete: '/delete',
          export: '/export',
          response: '/response',
        },
      },
    },
  },

  fileStore: {
    documentRoot: process.env.REACT_APP_digitalLibraryDocumentRoot,
    docs: [
      {
        code: QUERY_DOC_ID,
        path: 'procesos/consultas',
        namePreffix: '',
        nameSuffix: '',
      },
      {
        code: INTERVIEW_DOC_ID,
        path: 'procesos/entrevistas',
        namePreffix: '',
        nameSuffix: '',
      },
      {
        code: LEGAL_PROCESS_DOC_ID,
        path: 'procesos/procesos',
        namePreffix: '',
        nameSuffix: '',
      },
      {
        code: LEGAL_PROCESS_ACTION_DOC_ID,
        path: 'p/procesos/actuaciones',
        namePreffix: '',
        nameSuffix: '',
      },
      {
        code: CONCILIATION_REQUEST_DOC_ID,
        path: 'conciliación/solicitud',
        namePreffix: '',
        nameSuffix: '',
      },
      {
        code: CITATION_DOC_ID,
        path: 'conciliación/citación',
        namePreffix: '',
        nameSuffix: '',
      },
      {
        code: CONSTANCY_IMPOSSIBILITY_DOC_ID,
        path: 'conciliación/fracasadas',
        namePreffix: '',
        nameSuffix: '',
      },
      {
        code: CONCILIATION_ACT_DOC_ID,
        path: 'conciliación/actas',
        namePreffix: '',
        nameSuffix: '',
      },
      {
        code: CITATION_COMPLIANCE_DOC_ID,
        path: 'conciliación/cumplimiento',
        namePreffix: '',
        nameSuffix: '',
      },
      {
        code: ETHICAL_INBOX_DOC_ID,
        path: 'ethicalInbox',
        namePreffix: '',
        nameSuffix: '',
      },
    ],
  },

  companyTypes: [
    { _id: '', code: '-1', name: 'Elija el tipo' },
    { _id: '', code: 'PRI', name: 'Privada' },
    { _id: '', code: 'PUB', name: 'Pública' },
  ],

  matter: [
    { code: '-1', name: 'Elija la materia' },
    { code: 'CI', name: 'Civil' },
    { code: 'CO', name: 'Comercial' },
    { code: 'FA', name: 'Familia' },
    { code: 'OT', name: 'Otros' },
  ],

  identificationDocumentTypes: [
    { code: 'CC', name: 'Cédula de Ciudadanía' },
    { code: 'CE', name: 'Cédula de Extranjería' },
    { code: 'PS', name: 'Pasaporte' },
  ],

  processActionsStageCode: LEGAL_PROCESS_ACTION_DOC_ID,
  conciliationActDocumentName: 'Acta de Conciliación',
  constancyImpossibilityDocumentName: 'Constancia de Imposibilidad',
  companyAreas: {
    PROCESS: '001',
    CONCILIATION_CENTER: '002',
  },

  documents: {
    request: {
      matter: {
        headerTitle: 'Consultar Viabilidad de Audiencia de Conciliación',
        headerText:
          'El centro de conciliación atiende asuntos de familia, civil, comercial y otros, (TENGA EN CUENTA: no se adelantan procesos laborales y administrativos).  A continuación, provea la información de asunto a conciliar, en breve le indicaremos si es viable llevar a cabo la conciliación con nosotros y los pasos que debe seguir a continuación.',
        userSection: {
          personalTitle: 'Datos personales del solicitante',
          companyTitle: 'Datos de la Empresa Solicitante',
          details: '',
        },
        actsSection: {
          title: 'Hechos',
          details:
            'Narre la historia de lo que sucedió y que lo lleva a realizar esta solicitud ',
        },
        claimsSection: {
          title: 'Pretensiones',
          details:
            'Conforme a lo anterior, solicito muy atentamente (escriba en detalle lo que Ud. pretende obtener con esta conciliación)',
        },
        attorneySection: {},
        footerText: '',
        buttonTitle: 'Consultar viabilidad',
        postFooterText: '',
        successResponse: 'La solicitud ha sido enviada satisfactoriamente.',
        successRedirect: 'config.react_routes.prefix',
      },
      assessment: {
        headerTitle: 'Valoración de la solicitud de conciliación',
        headerText:
          'A continuación, se visualiza la información de la solicitud enviada por el usuario para evaluar su viabilidad',
        userSection: {
          title: 'Datos personales del solicitante',
          details: '',
        },
        actsSection: {
          title: 'Hechos',
          details: '',
          fixTitle: '',
          fixDetails: '',
        },
        claimsSection: {
          title: 'Pretensiones',
          details: '',
          fixTitle: '',
          fixDetails: '',
        },
        evidenceSection: {
          title: '',
          details: '',
        },
        rateSection: {
          title: '',
          details: '',
        },
        viableButtonTitle: 'Viable',
        rejectButtonTitle: 'No viable',
        footerText: '',
        postFooterText: '',
        buttonTitle: 'Consultar viabilidad',
        successResponse: 'La solicitud ha sido actualizada satisfactoriamente.',
        successRedirect: 'config.react_routes.prefix',
      },
      details: {
        headerTitle: 'Solicitud de Conciliación',
        headerText:
          'Ahora para concluir con su solicitud de conciliación, es necesario que envíe el resto de la información requerida.',
        userSection: {
          title: '',
          details: '',
        },
        actsSection: {
          title: '',
          details: '',
        },
        claimsSection: {
          title: '',
          details: '',
        },
        evidenceSection: {
          title: '',
          details: '',
        },
        paymentSection: {
          title: '',
          details: '',
        },
        footerText: '',
        buttonTitle: 'Enviar Solicitud',
        postFooterText: '',
        successResponse: 'La solicitud ha sido enviada satisfactoriamente.',
        successRedirect: 'config.react_routes.prefix',
      },
      approval: {
        headerTitle: 'Aprobación de Solicitud de Conciliación',
        headerText:
          'A continuación, revise toda la información adicional que envió el usuario (incluido el comprobante de pago) para realizar su aprobación o para indicarle al usuario lo que hace falta.',
        userSection: {
          title: '',
          details: '',
        },
        actsSection: {
          title: 'Hechos',
          details: '',
        },
        claimsSection: {
          title: 'Pretensiones',
          details: '',
        },
        evidenceSection: {
          title: 'Pruebas Aportadas',
          details: '',
        },
        paymentSection: {
          title: '',
          details: '',
        },
        approvalSection: {
          title: 'Aprobación de solicitud',
          details: 'Esta solicitud contiene toda la información requerida',
        },
        footerText: '',
        buttonTitle: 'Aprobar Solicitud',
        postFooterText: '',
        successResponse: 'La solicitud ha sido procesada satisfactoriamente.',
        successRedirect: 'config.react_routes.prefix',
      },
      publishResults: {
        headerTitle: 'Carga de Resultados de la Conciliación',
        headerText:
          'Carga del acta de conciliación o de la constancia de audiencia fracasada.',
        userSection: {
          title: '',
          details: '',
        },
        actsSection: {
          title: '',
          details: '',
        },
        claimsSection: {
          title: '',
          details: '',
        },
        evidenceSection: {
          title: '',
          details: '',
        },
        paymentSection: {
          title: '',
          details: '',
        },
        footerText: '',
        buttonTitle: 'Guardar Resultados',
        postFooterText: '',
        successResponse: 'La publicacio´n ha sido satisfactoria.',
        successRedirect: 'config.react_routes.prefix',
      },
      view: {
        headerTitle: 'Solicitud de Conciliación',
        headerText: 'Estado de la Solicitud de Conciliación',
        userSection: {
          title: '',
          details: 'Hola  ',
        },
        actsSection: {
          title: '',
          details: '',
        },
        claimsSection: {
          title: '',
          details: '',
        },
        evidenceSection: {
          title: '',
          details: '',
        },
        paymentSection: {
          title: '',
          details: '',
        },
        footerText: '',
        buttonTitle: 'Continuar',
        postFooterText: '',
        successRedirect: 'config.react_routes.prefix',
      },
      subtitles: {
        personalInfo: 'Datos Personales del Solicitante',
        companyInfo: 'Datos de la Empresa Solicitante',
        legalRepresentativeInfo: 'Representante Legal',
        acts: 'Hechos',
        claims: ' Pretensiones',
        attorney: 'Apoderado',
        convened: 'Convocados',
        docsRequired: 'Documentos Requeridos',
        rate: 'Tarifa',
        paymentTicket: 'Comprobante de pago',
        paymentDetails:
          'Puede realizar el pago mediante consignación en la siguiente ' +
          'cuenta de ahorros No 220040145401 del Banco Popular cuyo titular ' +
          'es la Fundación Servicio Jurídico Popular con el NIT No. 860030714-9.',
        providedEvidence: 'Evidencias Aportadas',
        results: 'Resultados',
        radicationNumber: 'Número de Solicitud',
        rejectedRequest: 'Solicitud no viable',
        viableResponse: 'La solicitud ha sido guardada viable.',
        noViableResponse: 'La solicitud ha sido guardada no viable.',
        audienceVideo: 'Video Audiencia',
      },
      statesForSearch: {
        started: 'Iniciada',
        viable: 'Viable',
        inviable: 'Inviable',
        approved: 'Aprobada',
        scheduled: 'Agendada',
        concilied: 'Conciliada',
        failed: 'Fracasada',
      },
      states: {
        concilied: 'Conciliada',
        failed: 'Fracasada',
        scheduled: 'Agendada',
        approved: 'Aprobada',
        placed: 'Enviada',
        payed: 'Pagada',
        valued: 'Tarificada',
        docRequiredSet: 'Documentos requeridos fijados',
        claimsAccepted: 'Pretensiones aprobadas',
        viable: 'Viable',
        inviable: 'Inviable',
        started: 'Iniciada',
        empty: 'Vacía',
      },
    },
    conciliationAct: {
      name: 'Acta de conciliación',
    },
    impossibilityConstancy: {
      name: 'Constancia de Audiencia Fracasada',
    },
  },
  ethicalInbox: {
    question: {
      request: {
        headerTitle: 'Realizar Pregunta',
        headerText:
          'Envíe una pregunta a la Fundación Servicio Jurídico Popular',
        footerText: '',
        buttonTitle: 'Enviar Pregunta',
        postFooterText: '',
        successResponse: 'La pregunta ha sido enviada satisfactoriamente.',
        successRedirect: 'config.react_routes.prefix',
      },
      response: {
        headerTitle: 'Conversación',
        headerText:
          'A continuación, encuentra la respuesta a la pregunta que Ud. realizó',
        responseButtonTitle: 'Enviar Respuesta',
        footerText: '',
        postFooterText: '',
        buttonTitle: 'Consultar respuesta',
        successResponse: 'La respuesta ha sido guardada satisfactoriamente.',
        successRedirect: 'config.react_routes.prefix',
      },
    },

    issue: {
      request: {
        headerTitle: 'Registrar una Denuncia',
        headerText:
          'Envíe una denuncia a la Fundación Servicio Jurídico Popular',
        footerText: '',
        buttonTitle: 'Enviar Denuncia',
        postFooterText: '',
        successResponse: 'La denuncia ha sido enviada satisfactoriamente.',
        successRedirect: 'config.react_routes.prefix',
      },
      response: {
        headerTitle: 'Respuesta a su Denuncia',
        headerText:
          'A continuación, encuentra la respuesta a la denuncia que Ud. realizó',
        responseButtonTitle: 'Enviar Respuesta',
        footerText: '',
        postFooterText: '',
        buttonTitle: 'Enviar Respuesta',
        successResponse: 'La respuesta ha sido guardada satisfactoriamente.',
        successRedirect: 'config.react_routes.prefix',
      },
    },
    states: {
      processed: 'Procesada',
      placed: 'Enviada',
      started: 'Iniciada',
      empty: 'Vacía',
    },
  },
  security: {
    roleNames: {
      undefinedRoleName: 'undefined',
      superAdminRoleName: 'SECOFER',
      associatedRoleName: 'associated',
      comercialManagerRoleName: 'comercialManager',
      comercialCoordinatorRoleName: 'comercialCoordinator',
      ABCRoleName: 'ABC',
      membershipManagerRoleName: 'membershipManager',
      creditManagerRoleName: 'creditManager',
    },
  },

  credit: {},
};

export const security = {
  roles: [
    {
      name: config.security.roleNames.undefinedRoleName,
      subordinateRoles: [],
    },
    {
      name: config.security.roleNames.superAdminRoleName,
      subordinateRoles: [
        config.security.roleNames.undefinedRoleName,
        config.security.roleNames.superAdminRoleName,
        config.security.roleNames.standarUserRoleName,
      ],
    },
    {
      name: config.security.roleNames.standarUserRoleName,
      subordinateRoles: [],
    },
  ],
};

export type DocumentTypeOption = {
  document_type_id: number;
  name: string;
};

export const getStageInfo = (state: string) => {
  switch (state) {
    case appConfig.documents.request.states.empty:
      return appConfig.documents.request.matter;
    case appConfig.documents.request.states.started:
      return appConfig.documents.request.assessment;
    case appConfig.documents.request.states.viable:
      return appConfig.documents.request.details;
    case appConfig.documents.request.states.placed:
      return appConfig.documents.request.approval;
    case appConfig.documents.request.states.approved:
      return appConfig.documents.request.publishResults;
    default:
      return appConfig.documents.request.view;
  }
};

export const generateJsonForVariables = () => {
  let vars = getAllVariablesFlat(appConfig);
  vars = vars
    .filter(item => item.startsWith('documents'))
    .map(item => 'appConfig.' + item);
  vars = vars.map((item, index) => {
    let h = item.split(' ')[0];
    const pn = h.split('/')[0].split('.').pop();
    const t = h.split('/')[1];
    h = h.split('/')[0];
    const v = item
      .split('=')[1]
      .trim()
      .replaceAll('"', '\\"')
      .replaceAll('\n', '')
      .replaceAll('\r', '');
    const out = `{ "order" : 0, "paramName" : "${pn}", "type" : "${t}", "title" : "", "description" : "", "environment" : "", "module" : "Conciliación", "group" : "", "subgroup" : "", "hierarchy" : "${h}", "value" : ${
      t === 'string' ? '"' + v + '"' : v
    } },`;
    return out;
  });
  console.log(vars.join('\n'));
};
